import React from 'react';
import { RecentSearchedTrainsListProps } from './RecentSearchedTrainsList.types';
import { getAppEnv } from '../../../../../../../config/env';
import { IMAGE_ALT_TEXT, LABELS } from '../../../../constants/LTSConstants';
import { TrainDetail } from '../../../../types/LTSTypes';

const env = getAppEnv();
const { PUBLIC_URL } = env.raw;

const RecentSearchedTrainsList = (props: RecentSearchedTrainsListProps) => {
  const { trainList, onClick } = props;

  const handleOnClick = (trainDetail: TrainDetail) => {
    onClick(trainDetail);
  };

  return (
    <div className="LTSTrainNumber-RecentSearchedTrainsList-wrapper">
      <div className="LTSTrainNumber-RecentSearchedTrainsList-header">
        <img src={`${PUBLIC_URL}/static/public/recent_ic.webp`} alt={IMAGE_ALT_TEXT.timer} />
        <span>{LABELS.RECENT_SEARCHES}</span>
      </div>
      <ul className="LTSPageCommon-ul">
        {trainList.map((item, index) => (
          <li
            className="LTSPageCommon-li LTSTrainNumber-RecentSearchedTrainsList-li LTSPageCommon-click-transition"
            key={`${item.trainNumber}-${index}`}
            onClick={() => handleOnClick(item)}
          >
            <span>{item.trainNumber}</span>
            <span className="LTSPageCommon-text-overflow-ellipsis">{item.trainName}</span>
          </li>
        ))}
      </ul>
    </div>
  );
};

export default RecentSearchedTrainsList;
